import { Component, Input, OnChanges, ViewChild } from '@angular/core';

import { Subscription } from 'rxjs';
import { cloneDeep } from 'lodash';


import { DropdownOptionModel } from '../../../Forms/models/dropdown-option.model';
import { AbstractFilterTypeComponent } from '../../models/abstract-filter-type.component';
import { FilterTypeModel } from '../../models/abstract-filter-type.model';
import { FilterGroupModel } from '../../models/filter-group.model';
import { FilterTypesEnum } from '../../enums/filters-types.enum';
import { IncludeExcludeEnum } from '../../enums/include-exclude.enum';
@Component({
    selector: 'agpr-filter-group',
    templateUrl: './filter-group.component.html',
    styleUrls: ['./filter-group.component.scss'],
    providers: [
        {
            provide: AbstractFilterTypeComponent,
            useExisting: FilterGroupComponent
        }
    ],
    standalone: false
})
export class FilterGroupComponent extends AbstractFilterTypeComponent implements OnChanges {
    @Input() declare filter: FilterGroupModel;

    @ViewChild(AbstractFilterTypeComponent) activeFilterComponent: AbstractFilterTypeComponent;

    readonly types = FilterTypesEnum;
    readonly includeExcludeEnum = IncludeExcludeEnum;

    filterOptions: DropdownOptionModel<FilterTypeModel>[];
    selectedFilter: DropdownOptionModel<FilterTypeModel>;

    subscriptions: Subscription[] = [];

    ngOnChanges(): void {
        this.refresh();
    }

    refresh(): void {
        this.filterOptions = this.filter.children.map(childFilter => {
            childFilter.showIncludeExclude = this.filter.showIncludeExclude;
            return {
                label: childFilter.label,
                value: childFilter
            };
        });
        if (!this.selectedFilter || this.filterOptions[0].value.id !== this.selectedFilter.value.id) {
            this.selectedFilter = this.filterOptions[0];
        }
        this.activeFilterComponent?.refresh();
    }
}
